import { LitElement, html, svg } from 'lit';

export class IconBell32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Bjelle</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.333 29a2.783 2.783 0 0 0 5.34 0M16 4V1M16 4a9.922 9.922 0 0 1 7.071 2.975A10.241 10.241 0 0 1 26 14.16c0 9.543 2 11.174 2 11.174H4s2-2.595 2-11.174c0-2.695 1.054-5.278 2.929-7.184A9.921 9.921 0 0 1 16 4v0Z"></path></svg>`; }
}
if (!customElements.get('f-icon-bell32', IconBell32)) {
  customElements.define('f-icon-bell32', IconBell32);
}